<template>
  <div class="row documento_dados_designacao">
    <div class="small-12 medium-8 large-7 columns">
      <div class="row">
        <div class="small-4 medium-4 large-4 columns">
          <h3 @click="$emit('itemclicked')" class="edital">{{ item.docprocedconcursal_edital }}</h3>
        </div>
        <div class="small-8 medium-8 large-8 columns">
          <h3>{{ item.docprocedconcursal_resumo }}</h3>
        </div>
      </div>
    </div>
    <div class="small-0 medium-4 large-5 columns hide-for-small-only">
      <div class="row">
        <div class="small-0 medium-6 large-4 columns">
          <h3>{{ item.docprocedconcursal_categoria_profissional.label }}</h3>
        </div>
        <div class="small-0 medium-0 large-4 columns show-for-large">
          <h3>{{ item.docprocedconcursal_datafim }}</h3>
        </div>
        <div class="small-0 medium-6 large-4 columns">
          <h3>{{ item.docprocedconcursal_estado.label }}</h3>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["item"],
  emits:["itemclicked"],
  setup() {


    return {}
  }
}
</script>

<style lang="scss" scoped>
.documento_dados_designacao,
.row .row {
  margin-right: 0px;
  margin-left: 0px;
}

.documento_dados_designacao .columns .columns {
  padding-right: 7px;
  padding-top: 7px;
  padding-bottom: 7px;
}

.documento_dados_designacao .columns {
  padding-left: 0;
  padding-right: 0;
}

.documento_dados_designacao h3 {
  font-family: "Montserrat";
  font-size: 15px;
  padding-top: 14px;
  color: #707475;
  padding-right: 20px;
}

.documento_dados_designacao .columns:last-of-type .columns:last-of-type {
  padding-right: 0px !important;
}

.documento_dados_designacao h3.edital {
  font-family: "Montserrat Bold";
  padding-left: 0;
}

.documento_dados_designacao h3.edital:hover{
  cursor: pointer;
}

.documento_dados_designacao {
  border-bottom: 1px solid #a7a5a5;
}

@media screen and (max-width:1024px) {
  .documento_dados_designacao h3 {
    font-size: 14px;
  }
}

@media screen and (max-width:767px) {
  .documento_dados_designacao h3 {
    font-size: 14px;
    padding-right: 0px;
    line-height: 1.6;
    padding-top: 6px;
  }  
}
</style>